export default "__VITE_ASSET__8LgZIhJm__"